// @mui
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import { alpha, styled } from '@mui/material/styles';

//
import { NavConfigProps, NavItemProps } from '../types';

// ----------------------------------------------------------------------

type StyledItemProps = Omit<NavItemProps, 'item'> & {
  config: NavConfigProps;
};

export const StyledItem = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'active'
})<StyledItemProps>(({ active, open, depth, config, theme }) => {
  const subItem = depth !== 1;

  const activeStyles = {
    root: {
      color: theme.palette.grey[100],
      //theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.primary.light,
      backgroundColor: alpha('#E9B300', 0.9),
      '&:hover': {
        backgroundColor: alpha('#E9B300', 0.9)
      }
    },
    sub: {
      color: '#E9B300',
      backgroundColor: alpha(theme.palette.grey[100], 0.1),
      '&:hover': {
        backgroundColor: alpha(theme.palette.grey[100], 0.1)
      }
    }
  };

  return {
    // Root item
    flexDirection: 'column',
    justifyContent: 'center',
    borderRadius: config.itemRadius,
    minHeight: config.itemRootHeight,
    color: theme.palette.grey[500],
    '&:hover': {
      backgroundColor: alpha(theme.palette.grey[100], 0.1)
    },
    margin: `0 ${config.itemGap}px ${config.itemGap}px ${config.itemGap}px`,
    ...(config.hiddenLabel &&
      !subItem && {
        padding: config.itemPadding
      }),

    // Active root item
    ...(active && {
      ...activeStyles.root
    }),

    // Sub item
    ...(subItem && {
      margin: 0,
      flexDirection: 'row',
      padding: theme.spacing(0, 1),
      minHeight: config.itemSubHeight,
      // Active sub item
      ...(active && {
        ...activeStyles.sub
      })
    }),

    // Open
    ...(open &&
      !active && {
        color: '#E9B300',
        backgroundColor: theme.palette.primary.light
      })
  };
});

// ----------------------------------------------------------------------

type StyledIconProps = {
  size?: number;
};

export const StyledIcon = styled(ListItemIcon)<StyledIconProps>(({ size }) => ({
  width: size,
  height: size,
  marginRight: 0
}));
